import DiscardIcon from '../../../../Icons/DiscardIcon';
import { IconButton } from '@coolblue-development/freddy';

interface DiscardButtonProps {
  onClick: () => void;
}

const DiscardButton = ({ onClick }: DiscardButtonProps): JSX.Element => {
  return (
    <IconButton
      onClick={onClick}
      data-testid="discard-button"
      size="small"
      sx={{
        width: 'auto',
        height: 'auto',
        padding: '8px',
        ':hover': { background: '#F3F3F3' }
      }}
      variant="transparent"
    >
      <DiscardIcon />
    </IconButton>
  );
};

export default DiscardButton;
